import { z } from 'zod'

const createEnv = () => {
  const EnvSchema = z.object({
    MODE: z.enum(['local', 'dev', 'prod', 'staging', 'test']),
    BACKEND_URL: z.string().url(),
    BASE_URL: z.string().url(),
    ASSETS_URL: z.string().url(),
    AWS_REGION: z.string().min(1),
    USER_POOL_ID: z.string().min(1),
    USER_POOL_WEB_CLIENT_ID: z.string().min(1),
    USER_POOL_JWKS_URL: z.string().url(),
    STREAM_API_KEY: z.string().min(1),
    STREAM_APP_ID: z.string().min(1),
    SENTRY_DSN: z.string().url(),
    STRIPE_PUBLISHABLE_KEY: z.string().regex(/^pk_/),
    LINK_TO_TERMS_OF_USE: z.string().url(),
    LINK_TO_PRIVACY_POLICY: z.string().url(),
    LINK_TO_HELP_CENTER: z.string().url(),
    LINK_TO_POINTS_PAGE: z.string().url(),
    LANDING_PAGE_URL: z.string().url(),
    IOS_APP_URL: z.string().url(),
    ANDROID_APP_URL: z.string().url(),
    GOOGLE_ADS_CONVERSION_ID: z.string().optional(),
    GOOGLE_ANALYTICS_ID: z.string().optional(),
    RECAPTCHA_SITE_KEY: z.string().optional(),
    SANITY_PROJECT_ID: z.string().min(1),
    SANITY_DATASET: z.string().min(1),
    SANITY_API_TOKEN: z.string().min(1),
  })

  const envVars = Object.entries(import.meta.env).reduce<Record<string, string>>((acc, curr) => {
    const [key, value] = curr
    if (key.startsWith('VITE_')) {
      acc[key.replace('VITE_', '')] = value
    }
    return acc
  }, {})

  const parsedEnv = EnvSchema.safeParse(envVars)

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided.
The following variables are missing or invalid:
${Object.entries(parsedEnv.error.flatten().fieldErrors)
  .map(([k, v]) => `- ${k}: ${v}`)
  .join('\n')}
`,
    )
  }

  return parsedEnv.data
}

export const env = createEnv()

export const getEnv = () => env.MODE

export const awsConfig = {
  Auth: {
    Cognito: {
      region: env.AWS_REGION,
      userPoolId: env.USER_POOL_ID,
      userPoolClientId: env.USER_POOL_WEB_CLIENT_ID,
    },
  },
}
